var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrongPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7493 12.3333L17.916 16.5M17.916 12.3333L13.7493 16.5M9.99935 11.9167H6.24935C5.08638 11.9167 4.50489 11.9167 4.03173 12.0602C2.96639 12.3834 2.13272 13.217 1.80955 14.2824C1.66602 14.7555 1.66602 15.337 1.66602 16.5M12.0827 5.25C12.0827 7.32107 10.4037 9 8.33268 9C6.26161 9 4.58268 7.32107 4.58268 5.25C4.58268 3.17893 6.26161 1.5 8.33268 1.5C10.4037 1.5 12.0827 3.17893 12.0827 5.25Z",
    stroke: "#00BBF6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongPersonIcon);
export default __webpack_public_path__ + "static/media/wrongPersonIcon.d763e5517eb7fa07d57fb7bace99e17c.svg";
export { ForwardRef as ReactComponent };